import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = { class: "d-flex justify-content-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "ms-2" }, "Xác nhận", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "ms-2" }, "Hủy", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.isDialogDisplay,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isDialogDisplay) = $event)),
    width: _ctx.width,
    onClose: _ctx.onCloseIconClickedHandler
  }, {
    title: _withCtx(() => [
      _createElementVNode("h3", _hoisted_1, _toDisplayString(_ctx.title), 1)
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_2, [
        _createVNode(_component_ButtonCustom, {
          "color-type": _ctx.ButtonTypeColors.PRIMARY,
          "button-type": _ctx.ButtonsType.REGULAR_QUESTION,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onConfirmButtonClickedHandler()))
        }, {
          "button-label": _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["color-type", "button-type"]),
        _createVNode(_component_ButtonCustom, {
          "color-type": _ctx.ButtonTypeColors.DANGER,
          "button-type": _ctx.ButtonsType.CANCEL,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onCloseButtonClickedHandler()))
        }, {
          "button-label": _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["color-type", "button-type"])
      ])
    ]),
    _: 3
  }, 8, ["modelValue", "width", "onClose"]))
}